var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumPrimaryCreditCard = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/credit card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/credit-card"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.000000, 11.000000)",
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.652,6.54503937 L39.652,4.56740157 C39.652,2.31086614 37.7235504,0.46 35.3129885,0.46 L4.43101151,0.46 C2.04723358,0.46 0.092,2.28551181 0.092,4.56740157 L0.092,6.54503937 C0.092,6.74787402 0.25270413,6.9 0.466976303,6.9 L39.2502397,6.9 C39.4645118,6.9 39.652,6.74787402 39.652,6.54503937 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.092,10.0282433 L0.092,22.9077792 C0.092,25.2328882 2.01914479,27.14 4.42807578,27.14 L35.3159242,27.14 C37.6980893,27.14 39.652,25.259013 39.652,22.9077792 L39.652,10.0282433 C39.652,9.8192447 39.4914046,9.66249579 39.2772774,9.66249579 L0.466722598,9.66249579 C0.252595399,9.63637097 0.092,9.8192447 0.092,10.0282433 Z M9.96861705,19.903425 C9.96861705,20.5565455 9.40653315,21.1051667 8.73738566,21.1051667 L7.50615426,21.1051667 C6.83700677,21.1051667 6.27492287,20.5565455 6.27492287,19.903425 L6.27492287,18.7016833 C6.27492287,18.0485628 6.83700677,17.4999416 7.50615426,17.4999416 L8.73738566,17.4999416 C9.40653315,17.4999416 9.96861705,18.0485628 9.96861705,18.7016833 L9.96861705,19.903425 Z",
    id: "Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumPrimaryCreditCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-primary-credit-card.c1f1d03204be8d58f4fdc6cb7cb82fca.svg";